import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-accent-500">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">
          加入今日同人库
        </h2>
        <p className="mt-4 text-sm md:text-base text-background-100 leading-relaxed">
          开启你的同人创作之旅。订阅我们的每日推荐，让好作品主动找到你。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <div className="flex items-center bg-background-50 rounded-full overflow-hidden w-full sm:w-auto max-w-md">
            <input
              type="email"
              name="email"
              placeholder="输入你的邮箱地址"
              className="flex-1 px-5 py-3.5 bg-transparent text-foreground-900 text-sm outline-none min-w-0"
            />
            <button
              type="submit"
              className="px-6 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              订阅
            </button>
          </div>
        </div>
        <p className="mt-4 text-xs text-background-200">免费订阅，随时可退订。我们会保护你的隐私。</p>
      </div>
    </section>
  );
}